/* Lossless pint selections and Shopify-priced pack lines. */
(function(root,factory){if(typeof module==='object'&&module.exports)module.exports=factory(require('./souvenir-pint-pricing.js'));else root.SouvenirPintCartModel=factory(root.SouvenirPintPricing);})(globalThis,pricing=>{
 'use strict';
 function readCart(cart,catalog,productId){
  const known=new Set(catalog.map(d=>d.id)), glasses=[],lines=[],others=[],invalid=[];let surcharges=0;
  for(const item of cart.items){
   const pack=String(item.product_id)===String(productId),single=/^(PINT-[A-F0-9]+)-S([12])$/.exec(item.sku||'');
   if(!pack&&!single){others.push(item);continue;}
   lines.push(item);let selection=[];
   if(!Number.isInteger(item.quantity)||item.quantity<1){invalid.push(item);continue;}
   if(!pack){if(!known.has(single[1])){invalid.push(item);continue;}selection=[{id:single[1],sides:Number(single[2])}];}
   else if(item.sku==='PINT-MIX-DOUBLE'){surcharges+=item.quantity;continue;}
   else{
    const match=/^PINT-MIX-P(\d+)$/.exec(item.sku||'');const count=match?Number(match[1]):/^PINT-MIX-V(LOW|HIGH)$/.test(item.sku||'')?1:0;
    if(count<1||count>120){invalid.push(item);continue;}
    for(let i=1;i<=count;i++){const [id,side]=String(item.properties?.[`Glass ${i}`]||'').split(' | ');selection.push({id,sides:side==='Double Sided'?2:side==='Single Sided'?1:0});}
    if(selection.some(s=>!known.has(s.id)||!s.sides)){invalid.push(item);continue;}
   }
   if(glasses.length+selection.length*item.quantity>10000)throw Error('Contact us for orders over 10,000 glasses.');
   for(let q=0;q<item.quantity;q++)glasses.push(...selection);
  }
  const double=glasses.filter(s=>s.sides===2).length;
  return {glasses,lines,others,invalid,double,surcharges};
 }
 function plan(selection,catalog,variants,token){
  const known=new Map(catalog.map(d=>[d.id,d])),double=selection.filter(s=>s.sides===2).length,expected=pricing.total(selection.length,double),items=[];
  if(selection.some(s=>!known.has(s.id)||![1,2].includes(s.sides)))throw Error('Review your glass designs and engraving sides.');
  function add(sku,chosen,price,quantity=1){
   const v=variants.find(v=>v.sku===sku);if(!v||!v.available||Number(v.price)!==price)throw Error('Glass ordering is being prepared. Please try again later.');
   const properties={_pint_version:'1',_pint_transaction:token,_pint_chunk:String(items.length)};
   if(chosen.length){properties['Glass count']=String(chosen.length);chosen.forEach((s,i)=>properties[`Glass ${i+1}`]=`${s.id} | ${s.sides===2?'Double Sided':'Single Sided'} | ${known.get(s.id).title.slice(0,150)}`);}
   else properties['Engraving']='Second-side engraving for the double-sided glasses in this set; same design on both sides.';
   items.push({id:Number(v.id),quantity,properties});
  }
  const n=selection.length;
  if(n&&n<120)add(`PINT-MIX-P${n}`,selection,pricing.total(n));
  else if(n){const full=Math.floor(n/120);for(let i=0;i<full;i++)add('PINT-MIX-P120',selection.slice(i*120,(i+1)*120),100100);const rest=selection.slice(full*120),high=pricing.total(n)-full*100100-rest.length*834;rest.forEach((s,i)=>add(i<high?'PINT-MIX-VHIGH':'PINT-MIX-VLOW',[s],i<high?835:834));}
  if(double)add('PINT-MIX-DOUBLE',[],220,double);
  return {items,expected};
 }
 function sameLines(actual,expected){return actual.length===expected.length&&expected.every(w=>actual.filter(a=>String(a.variant_id)===String(w.id)&&a.quantity===w.quantity&&Object.keys(w.properties).every(k=>a.properties?.[k]===w.properties[k])).length===1);}
 return {readCart,plan,sameLines,total:pricing.total};
});
